import { ApiError } from './api-error';

export class MethodNotAllowedError extends ApiError {}
